import { render, staticRenderFns } from "./EstablishmentRoleForm.vue?vue&type=template&id=081e7560&"
import script from "./EstablishmentRoleForm.vue?vue&type=script&lang=js&"
export * from "./EstablishmentRoleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports